module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAASCAYAAACNdSR1AAAAAXNSR0IArs4c6QAAAKRJREFUKBVjYAACZ2fnLE9PT1EQGx9gAin89+/f1J8/f+4npIGJjY1tNSMj49X///9rE9LACLIWZCJIIUgDSCM7O7vj9u3bX6M7CayYWA1wxcRoQFFMSAOGYnwasCrGpYEJJEEswGoyrqDEUIxLIch2FMX4FKIoJqQQrpgYhWDFwFQnDEwTBwmlC5BiJiEhoc9A+j6+BARSCAehoaFsIBvgAjgYAOoMqgKq8UXyAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/arrow_left.png
// module id = 120
// module chunks = 7